import React, { Component } from "react";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleInput from "../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";

class InventoryPartFilter extends Component {
  constructor(props) {
    super(props);
    this.INITIAL_FILTER = {
      partCode: null,
      partName: null,
      category: null,
      locator: null,
    };
    this.state = {
      filterData: this.INITIAL_FILTER,
    };
  }

  componentDidMount() {
    const { submittedFilterrest } = this.props;
    if (submittedFilterrest) {
      this.setState({ filterData: submittedFilterrest });
    }
  }

  handleChangeFilter = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      filterData: {
        ...prev.filterData,
        [name]: value,
      },
    }));
  };

  handleReset = () => {
    this.setState({ filterData: this.INITIAL_FILTER });
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { filterData } = this.state;
    onSubmit(filterData);
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { filterData } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          visible={visible}
          styles={{ width: "40%" }}
          title="Cetak Inventory"
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <SimpleInput
                id="input_kode_part"
                name="partCode"
                label="Kode Part"
                value={filterData.partCode}
                onChange={({ target }) =>
                  this.handleChangeFilter(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_nama_part"
                name="partName"
                label="Nama Part"
                value={filterData.partName}
                onChange={({ target }) =>
                  this.handleChangeFilter(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_kategori_part"
                name="category"
                label="Kategori"
                value={filterData.category}
                onChange={({ target }) =>
                  this.handleChangeFilter(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_locator_part"
                name="locator"
                label="Locator"
                value={filterData.locator}
                onChange={({ target }) =>
                  this.handleChangeFilter(target.name, target.value)
                }
              />
              <FlexView hAlignContent="right">
                <SimpleButton
                  id="btn_reset_filter"
                  text="Hapus"
                  onClick={this.handleReset}
                />
                <SimpleButton
                  id="btn_reset_filter"
                  text="Terapkan"
                  onClick={this.handleSubmit}
                />
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default InventoryPartFilter;